import type { Icon } from "@phosphor-icons/react";
import { BankIcon } from "@phosphor-icons/react/dist/csr/Bank";
import { EnvelopeIcon } from "@phosphor-icons/react/dist/csr/Envelope";
import { FileTextIcon } from "@phosphor-icons/react/dist/csr/FileText";
import { LightningIcon } from "@phosphor-icons/react/dist/csr/Lightning";
import { ListChecksIcon } from "@phosphor-icons/react/dist/csr/ListChecks";
import { ReceiptIcon } from "@phosphor-icons/react/dist/csr/Receipt";
import { StorefrontIcon } from "@phosphor-icons/react/dist/csr/Storefront";
import type { ApTabValue } from "./utils";

const AP_TAB_ICON: Record<ApTabValue, Icon> = {
  review: ListChecksIcon,
  automated: LightningIcon,
  invoices: FileTextIcon,
  receipts: ReceiptIcon,
  emails: EnvelopeIcon,
  vendors: StorefrontIcon,
  quickbooks: BankIcon,
};

export const apTabIcon = (tab: ApTabValue): Icon => AP_TAB_ICON[tab];
